import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

// Admin v2 (JWT on every route, djr-be routes/admin.js):
// - GET   /admin/me/preferences -> { theme } ("noir" when unset)
// - PATCH /admin/me/preferences { theme: "noir" | "after-dark" } -> { theme }
// - GET   /admin/summary -> { nextEvents, songRequests, leads, money: { sums } }
const adminApi = createApi({
  reducerPath: "adminApi",
  baseQuery: prepareBaseQuery(""),
  tagTypes: ["AdminPreferences", "AdminSummary", "AdminPortalInbox"],
  endpoints: (builder) => ({
    getMyPreferences: builder.query({
      query: () => ({ url: "/admin/me/preferences", method: "GET" }),
      providesTags: ["AdminPreferences"],
    }),
    updateMyPreferences: builder.mutation({
      query: (body) => ({ url: "/admin/me/preferences", method: "PATCH", body }),
      // Instant switch: the cached preference changes before the server
      // answers and goes back if the save fails.
      async onQueryStarted(body, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          adminApi.util.updateQueryData("getMyPreferences", undefined, (draft) => {
            if (draft && typeof draft === "object") Object.assign(draft, body ?? {});
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),
    getAdminSummary: builder.query({
      query: () => ({ url: "/admin/summary", method: "GET" }),
      providesTags: ["AdminSummary"],
      keepUnusedDataFor: 120,
    }),
  }),
});

export const {
  useGetMyPreferencesQuery,
  useUpdateMyPreferencesMutation,
  useGetAdminSummaryQuery,
} = adminApi;

export default adminApi;
export { adminApi };
